import React from "react";
import Form from "@rjsf/core";
import validator from "@rjsf/validator-ajv8";
import RightArrowIcon from "../../icons/rightArrow";
import LeftArrowIcon from "../../icons/leftArrow";
import useMediaQuery from "../../hooks/useMediaQuery";
import Button from "../../components/button";
import LoadingButton from "../../components/loadingButton";
import ErrorMessage from "../../components/errorMessage";
import styles from "./style.module.css";
import formStyles from "../../components/form/style.module.css";

const schema = {
  type: "object",
  required: ["email"],
  properties: {
    email: {
      title: "Email Address",
      type: "string",
    },
  },
};

const uiSchema = {
  "ui:classNames": `${formStyles.formInner} ${styles.form_inner}`,
  "ui:rootFieldId": "forgot_step1",
  email: {
    "ui:classNames": `${formStyles.form_field} ${formStyles.col_12}`,
    "ui:placeholder": "youremail@gmail.com",
  },
  "ui:submitButtonOptions": {
    props: {
      className: formStyles.form_btn,
    },
  },
};

const Step1 = ({
  formData,
  onFormSubmit,
  onBackClick,
  loading,
  errorMessage,
}) => {
  const isMobile = useMediaQuery("(max-width: 767px)");
  return (
    <div className={styles.form_outer}>
      {isMobile && (
        <div className={styles.form_back}>
          <div className={styles.form_back_btn} onClick={onBackClick}>
            <LeftArrowIcon />
          </div>
        </div>
      )}
      <div className={styles.form_title}>Forgot password</div>
      <div className={styles.form_subtitle}>
        Please enter your email to reset the password
      </div>
      <Form
        className={`${formStyles.form}`}
        schema={schema}
        uiSchema={uiSchema}
        formData={formData}
        validator={validator}
        showErrorList={false}
        omitExtraData={true}
        liveValidate={false}
        onSubmit={({ formData }) => {
          onFormSubmit(formData);
        }}
      >
        <div className={styles.form_btn_container}>
          <Button
            title={"Back"}
            onClick={onBackClick}
            startIcon={<LeftArrowIcon />}
          />
          <LoadingButton
            type="submit"
            loading={loading}
            title={"Reset Password"}
            icon={<RightArrowIcon />}
          />
        </div>
      </Form>
      {errorMessage && <ErrorMessage message={errorMessage} mt />}
    </div>
  );
};

export default Step1;
